/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DatapointResponseVersionAuthorOrganizationDto } from "./DatapointResponseVersionAuthorOrganizationDto.ts"

export const datapointResponseVersionSnapshotDtoScopeEnum = {
  Operation: "Operation",
  CustomFieldValue: "CustomFieldValue",
  ProdsiteFieldValue: "ProdsiteFieldValue",
  CertificateRequest: "CertificateRequest",
} as const

export type DatapointResponseVersionSnapshotDtoScopeEnumKey =
  (typeof datapointResponseVersionSnapshotDtoScopeEnum)[keyof typeof datapointResponseVersionSnapshotDtoScopeEnum]

export type DatapointResponseVersionSnapshotDto = {
  /**
   * @type string, uuid
   */
  id: string
  /**
   * @type string
   */
  scope: DatapointResponseVersionSnapshotDtoScopeEnumKey
  /**
   * @type string
   */
  value: string
  /**
   * @type boolean
   */
  isFirstHand: boolean
  /**
   * @type string, uuid
   */
  authorOrganizationId: string
  /**
   * @type object
   */
  authorOrganization: DatapointResponseVersionAuthorOrganizationDto
  /**
   * @type string, uuid
   */
  responsibleOrganizationId: string
  /**
   * @type string, uuid
   */
  documentId: string | null
  /**
   * @type string, uuid
   */
  productionSiteId: string | null
  /**
   * @type string
   */
  reference: string | null
  /**
   * @type string
   */
  purchaseOrderRef: string | null
  /**
   * @type string
   */
  scopedTargetId: string
  /**
   * @type string, date-time
   */
  updatedAt: Date
}
